module.exports = __webpack_public_path__ + "img/image37.f6a928e6.webp";